import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import WsModalCreateContent from 'pages/ws/components/modalCreateContent/WsModalCreateContent';
import WsIndexContentsPublished from './components/WsIndexContentsPublished';
import WsIndexContentsUnpublished from './components/WsIndexContentsUnpublished';
import WsIndexHeader from './components/WsIndexHeader';
import WsIndexPlanBanner from './components/WsIndexPlanBanner';
import WsIndexUsage from './components/WsIndexUsage';
import { useWsIndex } from './hooks/useWsIndex';

import type { JSX } from 'react';

/**
 * ホーム画面
 */
export default function WsIndex(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  const {
    modalCreateContentOpen,
    setModalCreateContentOpen,
    onModalCreateContentOpen,
    isTrial,
    isExpiredPlan,
  } = useWsIndex(acctState);

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-header">
        <WsIndexPlanBanner
          isTrial={isTrial}
          isExpiredPlan={isExpiredPlan}
          planEndAt={acctState.company.plan.endAt}
        />
        <WsIndexHeader userName={acctState.user.name} onCreateContent={onModalCreateContentOpen} />
      </section>

      {/* 利用状況 */}
      <WsIndexUsage />
      {/* 直近のコンテンツレポート */}
      <WsIndexContentsPublished />

      <section className="section-topics">
        <div className="container">
          <div className="row row-15-xl">
            {/* 作成中のコンテンツ */}
            <WsIndexContentsUnpublished />
            {/* ヘルプ&トピックス */}
            {/* <WsIndexHelpAndTopics /> */}
          </div>
        </div>
      </section>

      {/* コンテンツ作成モーダル */}
      <WsModalCreateContent open={modalCreateContentOpen} setOpen={setModalCreateContentOpen} />
    </>
  );
}
